import { pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('24', '28', 'BOLD')};
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 1rem;

  .ant-form-item {
    margin-bottom: 0;
  }
`;
